module.exports = __webpack_public_path__ + "img/speech.296d0b71.svg";